module.exports = __webpack_public_path__ + "static/media/arrow_forward_40px_active.ab05fcf0.svg";